import type { App } from 'vue';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import VueForm from '@lljj/vue3-form-element';
import ImageCache from '@/components/image/Image.vue';
import { Done } from '@xpos/icons-svg';
import LanguageButton from '@/forms/widgets/LanguageButton.vue';
import PrinterScanButton from '@/forms/widgets/PrinterScanButton.vue';
import PrinterSelect from '@/forms/widgets/PrinterSelect.vue';
import UsbPrinterSelect from '@/forms/widgets/UsbPrinterSelect.vue';
import PrinterTemplateSelect from '@/forms/widgets/PrinterTemplateSelect.vue';
import DeviceSelect from '@/forms/widgets/DeviceSelect.vue';
import ColorDropdown from '@/forms/widgets/ColorDropdown.vue';
import IconDropdown from '@/forms/widgets/IconDropdown.vue';
import EmojiPickerWidget from '@/forms/widgets/EmojiPickerWidget.vue';
import MenuIconDropdown from '@/forms/widgets/MenuIconDropdown.vue';
import CategoryMultiSelect from '@/forms/widgets/CategoryMultiSelect.vue';
import ChangePassword from '@/forms/widgets/ChangePassword.vue';
import RoleDropdown from '@/forms/widgets/RoleDropdown.vue';
import ProductMultiSelect from '@/forms/widgets/ProductMultiSelect.vue';
import CategorySelect from '@/forms/widgets/CategorySelect.vue';
import ProductSelect from '@/forms/widgets/ProductSelect.vue';
import PrintTypeSelect from '@/forms/widgets/PrintTypeSelect.vue';
import UploadWidget from '@/forms/widgets/UploadWidget.vue';
import MultipleUploadWidget from '@/forms/widgets/MultipleUploadWidget.vue';
import TagInputSelectWidget from '@/components/FormWidget/TagInputSelectWidget/index.vue';
import PhoneInputWidget from '@/components/FormWidget/PhoneInputWidget/index.vue';
import UploadFileWidget from '@/forms/widgets/UploadFileWidget.vue';
import CountrySelect from '@/forms/widgets/CountrySelect.vue';
import CountryCodeSelect from '@/forms/widgets/CountryCodeSelect.vue';
import UploadImageWidget from '@/forms/widgets/UploadImageWidget.vue';
import CashDrawerTest from '@/forms/widgets/CashDrawerTest.vue';
import TimeRangeWidget from '@/forms/widgets/TimeRangeWidget.vue';
import OpeningScheduleWidget from '@/forms/widgets/OpeningScheduleWidget.vue';
import PermissionSelect from '@/forms/widgets/PermissionSelect.vue';
import FontSizeWidget from '@/forms/widgets/FontSizeWidget.vue';

// Register global components: Element Plus icons, shared components and formschema widgets
export default (app: App) => {
  // 175 kb
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) app.component(key, component);
  // frequently used components
  app.component('icon-done', Done);
  app.component('vue-form', VueForm);
  app.component('ImageCache', ImageCache);
  // formschema widgets
  app.component('LanguageButton', LanguageButton);
  app.component('PrinterScanButton', PrinterScanButton);
  app.component('PrinterSelect', PrinterSelect);
  app.component('UsbPrinterSelect', UsbPrinterSelect);
  app.component('PrinterTemplateSelect', PrinterTemplateSelect);
  app.component('DeviceSelect', DeviceSelect);
  app.component('ColorDropdown', ColorDropdown);
  app.component('IconDropdown', IconDropdown);
  app.component('EmojiPickerWidget', EmojiPickerWidget);
  app.component('MenuIconDropdown', MenuIconDropdown);
  app.component('CategoryMultiSelect', CategoryMultiSelect);
  app.component('RoleDropdown', RoleDropdown);
  app.component('ChangePassword', ChangePassword);
  app.component('ProductMultiSelect', ProductMultiSelect);
  app.component('CategorySelect', CategorySelect);
  app.component('ProductSelect', ProductSelect);
  app.component('PrintTypeSelect', PrintTypeSelect);
  app.component('UploadImageWidget', UploadWidget);
  app.component('UploadImageNewWidget', UploadImageWidget);
  app.component('MultipleUploadImageWidget', MultipleUploadWidget);
  app.component('TagInputSelect', TagInputSelectWidget);
  app.component('PhoneInputWidget', PhoneInputWidget);
  app.component('UploadFileWidget', UploadFileWidget);
  app.component('CountrySelect', CountrySelect);
  app.component('CountryCodeSelect', CountryCodeSelect);
  app.component('CashDrawerTest', CashDrawerTest);
  app.component('TimeRangeWidget', TimeRangeWidget);
  app.component('OpeningScheduleWidget', OpeningScheduleWidget);
  app.component('FontSizeWidget', FontSizeWidget);
  app.component('PermissionSelect', PermissionSelect);
};
